<script setup lang="ts">
import { onMounted, ref } from "vue";

import type { LanguageText } from "@/types/config";

import translatedProperty from "@/mixins/translatedProperty";

import UCInput from "@/components/ui/UCInput.vue";

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  fieldId: {
    type: String,
    required: true,
  },
  label: {
    type: Object,
    required: true,
  },
  field: {
    type: Object,
    required: true,
  },
  error: {
    type: String,
  },
});
const emit = defineEmits(["change"]);

const label = ref(props.label as LanguageText);
const value = ref(props.field.textarea.value || "");

function emitChange() {
  emit("change", props.id, value.value);
}
onMounted(() => {
  emitChange();
});
</script>
<template>
  <div class="add-integration__field add-integration__field--textarea">
    <UCInput
      v-model="value"
      @input="emitChange"
      :label="translatedProperty(label)"
      :type="'textarea'"
      :full-w="true"
      :error-message="error"
    />
  </div>
</template>
